


















import { defineComponent, reactive, computed } from '@vue/composition-api';
import type { PropType } from '@nuxtjs/composition-api';
import VueScrollTo from 'vue-scrollto';
import type { ProductProcessedAttributes } from '~/types/product/attribute/ProductProcessedAttributes';
import TrustAccordionItem from '~/components/molecules/Product/TrustAccordion/TrustAccordionItem.vue';
import ProductHighLights from '~/components/molecules/Product/details/ProductHighlights.vue';
import DeliveryDetails from '~/components/molecules/Product/TrustAccordion/DeliveryDetails.vue';
import ReturnsAndWarranty from '~/components/molecules/Product/TrustAccordion/ReturnsAndWarranty.vue';
import ProductDownloads from '~/components/molecules/Product/details/ProductDownloads/ProductDownloads.vue';
import { ACCORDION_KEYS } from '~/constants/trustAccordionKeys';
import type { AccordionKey } from '~/constants/trustAccordionKeys';
import type { AccordionItem } from '~/types/product/TrustAccordion';

export default defineComponent({
  name: 'TrustAccordion',
  components: {
    TrustAccordionItem,
    ProductHighLights,
    DeliveryDetails,
    ReturnsAndWarranty,
    ProductDownloads,
  },
  props: {
    attributesLocalized: {
      type: Object as PropType<ProductProcessedAttributes>,
      required: true,
    },
    manual: {
      type: String,
      required: true,
    },
    shouldShowRelatedAccessories: {
      type: Boolean,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const accordionState = reactive<Record<AccordionKey, boolean>>({
      [ACCORDION_KEYS.KEY_FEATURES]: true,
      [ACCORDION_KEYS.DELIVERY]: false,
      [ACCORDION_KEYS.RETURNS_WARRANTY]: false,
      [ACCORDION_KEYS.DOWNLOADS]: false,
      [ACCORDION_KEYS.ACCESSORIES]: false,
    });

    const canShowHighlights = computed(() => !!props.attributesLocalized.highlights?.length);
    const accordionItems = computed<AccordionItem[]>(() => [
      ...canShowHighlights.value
        ? [{
          title: 'Key features',
          key: ACCORDION_KEYS.KEY_FEATURES,
          icon: 'iconify svg--trophy',
          component: ProductHighLights,
          props: {
            value: props.attributesLocalized.highlights,
          },
        }]
        : [],
      ...props.shouldShowRelatedAccessories
        ? [{
          title: 'Accessories',
          key: ACCORDION_KEYS.ACCESSORIES,
          icon: 'iconify svg--accessories',
          component: null,
          props: {},
        }]
        : [],
      {
        title: 'Delivery details',
        key: ACCORDION_KEYS.DELIVERY,
        icon: 'iconify svg--truck-empty',
        component: DeliveryDetails,
      },
      {
        title: 'Returns and warranty',
        key: ACCORDION_KEYS.RETURNS_WARRANTY,
        icon: 'iconify svg--shield',
        component: ReturnsAndWarranty,
      },
      {
        title: 'Downloads',
        key: ACCORDION_KEYS.DOWNLOADS,
        icon: 'iconify svg--download-file text-xl',
        component: ProductDownloads,
        props: {
          manual: props.manual,
          sku: props.sku,
        },
      },
    ]);

    const onAccordionClicked = (item: AccordionItem): void => {
      if (item.key === ACCORDION_KEYS.ACCESSORIES) {
        if (props.shouldShowRelatedAccessories) {
          VueScrollTo.scrollTo('#product-accessories');
        }
      } else {
        accordionState[item.key] = !accordionState[item.key];
      }
    };

    return { accordionState, onAccordionClicked, accordionItems };
  },
});
